export class MicroappEpsPaypalListFilter{
    general: string;
    rol: string;
    tenant: string;
}